import {CreditCard} from './credit-card';
import {UtilitiesService} from '../services/utilities.service';

export class NewPolicy {
  Id: string;
  PlanId: string;
  CreditCard: CreditCard;
  ElectronicCheck: CreditCard;
  Options: OptionalItemInfo[];
  EmailOrderTo: string;
  IsMonthly: boolean;
  CouponCode: string;
  CreditCardId: string;
  Property: PropertySummary;
  CancellationDate: Date;
  CancellationPolicyId: string;
  CoverageLength: number;
  MarketingSourceId: string;
  WebUserId: string;
  ShowAdminFee: boolean;
  ReferralName: string;
  CustomerId: string;
  OriginalPolicyId: string;
  Buyer: CustomerSummary;
  Seller: CustomerSummary;
  EscrowOfficerId: string;
  EstimatedClosingDate: Date;
  EscrowResponsibleParty: string;
  EscrowNumber: string;
  AdditionalNotes: string;
  PreferredContactMethod = 'Phone';
  PlanName: string;
  PlanPrice: number;
  InitiatingAgentType = 'Selling';
  SellersCoverage = false;
  BuyersAgentId: string;
  Tenant: string = "5EA8C224-B3FF-4F11-B09F-5EC0C65266EC";


  constructor() {
    this.Id = UtilitiesService.newid();
    this.Property = new PropertySummary();
    this.Options = [];
    this.Buyer = new CustomerSummary();
    this.Seller = new  CustomerSummary();
  }
}

export class CustomerSummary {
  FirstName: string;
  LastName: string;
  MailingAddress: string;
  MailingCity: string;
  MailingState: string;
  MailingZip: string;
  MailingCountry: string;
  HomePhone: string;
  CellPhone: string;
  Email: string;
  Tenant: string = "5EA8C224-B3FF-4F11-B09F-5EC0C65266EC";
}

export class PropertySummary {
  Address: string;
  City: string;
  State: string;
  Zip: string;
  SquareFootage: number;
  DwellingType: string;
  YearBuilt: number;
  Country: string;
  Tenant: string = "5EA8C224-B3FF-4F11-B09F-5EC0C65266EC";
}

export class OptionalItemInfo {
  Id: string;
  Name: string;
  Sort: number;
  FullPrice: number;
  MonthPrice: number;
  AllowMultiple: boolean;
  SalesItemCoverageId: string;
  InSelectAreas: boolean;
  SalesItemId: string;
  OptionalItemId: string;
  Tenant: string = "5EA8C224-B3FF-4F11-B09F-5EC0C65266EC";
}
